<script setup lang="ts">
defineProps<{ to: string }>();
</script>

<template>
    <v-list-item class="menu-item" density="comfortable">
        <v-list-item-title>
            <RouterLink class="link" :to="to">
                <slot></slot>
            </RouterLink>
        </v-list-item-title>
    </v-list-item>
</template>

<style lang="css" scoped>
.link {
    color: #000;
}
</style>
